import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');

  :root {
    --primary: #ed765e;
    --primary-hover: #d66a54;
    --background-dark: #121212;
    --surface-dark: #1E1E1E;
    --surface-light: #2A2A2A;
    --accent-brown: #382C22;
    --accent-brown-light: #5D4037;
    --text-muted: #A1A1AA;
    --font-display: 'Manrope', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: var(--font-display), -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--background-dark);
    color: #ffffff;
    line-height: 1.5;
    overflow: hidden; /* Prevent body scroll as main container handles it */
    height: 100vh;
  }

  #root {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  input, textarea, select {
    font-family: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  /* Custom Scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: var(--accent-brown) var(--surface-dark);
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: var(--surface-dark);
  }

  *::-webkit-scrollbar-thumb {
    background-color: var(--accent-brown-light);
    border-radius: 4px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: var(--primary);
  }

  /* Utilities */
  .text-primary {
    color: var(--primary);
  }
`;